import { Loader2 } from "lucide-react";

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export function Loading({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-400">
      <Loader2 className="animate-spin mr-2" size={18} /> {label}
    </div>
  );
}

const statusMap = {
  Managed: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  Refurbishment: "bg-amber-50 text-amber-700 ring-amber-600/20",
  Sale: "bg-blue-50 text-blue-700 ring-blue-600/20",
  Letting: "bg-violet-50 text-violet-700 ring-violet-600/20",
  "To Do": "bg-slate-100 text-slate-600 ring-slate-500/20",
  "In Progress": "bg-blue-50 text-blue-700 ring-blue-600/20",
  Blocked: "bg-red-50 text-red-700 ring-red-600/20",
  Done: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  Urgent: "bg-red-50 text-red-700 ring-red-600/20",
  High: "bg-amber-50 text-amber-700 ring-amber-600/20",
  Medium: "bg-blue-50 text-blue-700 ring-blue-600/20",
  Low: "bg-slate-100 text-slate-600 ring-slate-500/20",
};

export function Badge({ children }) {
  const cls = statusMap[children] || "bg-slate-100 text-slate-600 ring-slate-500/20";
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}>
      {children}
    </span>
  );
}

export function Card({ children, className = "", ...props }) {
  return <div className={`bg-white border border-slate-200 rounded-xl shadow-sm ${className}`} {...props}>{children}</div>;
}
